<template>
  <div class="page-home">
    <div>
      <t-parallax-bar :backgroundImage="`${$config.images['HEADER_BACKGROUND']}`">

        <template v-if="$forSize['desktop-up']" v-slot:start>
          <img class="logo" v-bind:title="sysVersion" :src="$config.images['logo']" aria-label="Logo" />
        </template>

        <template v-else v-slot:start>
          <btn-menu color="var(--on-header)"/>
        </template>

        <template v-if="!$forSize['desktop-up']" v-slot:middle>
          <img class="mobile-logo" v-bind:title="sysVersion" :src="$config.images['logo']" />
        </template>

        <template v-if="$forSize['desktop-up']" v-slot:end>
          <div class="router-items">
            <routes color="var(--on-header)" highlightColor="var(--secondary-dark)"/>
          </div>
        </template>

        <template v-else v-slot:end>
          <login-menu />
        </template>

        <template v-slot:body>

          <div class="ebook-premiado-img">
            <img v-if="$config.featureFlags['EXIBIR_IMAGEM_ebookPremiado']" :src="$config.images['ebookPremiado']" />
          </div>

          <div class="header-content-description">
            <span v-html="$config.strings['home-banner-1']" />
            <span v-html="$config.strings['home-banner-2']" />
            <span v-html="$config.strings['home-banner-3']" />
          </div>

          <div>
            <login-card />
          </div>

        </template>
      </t-parallax-bar>

      <barra-assinatura />

      <div v-if="$config.featureFlags['EXIBIR_AREA_CATALOGO']" class="content" :style="{ backgroundImage: `url('${this.$config.images['zemaBkgPattern']}')` }">

        <h1 class="page-title" v-html="$config.strings['home-catalog-title']" />

        <div class="page-description" v-html="$config.strings['home-catalog-description']" />

        <t-hs-list :firstItemSpacing="true" :items="sample" @click="showDetail" />

        <div class="btn-ver-todos-os-cursos">
          <t-button
            :backgroundColor="$config.colors.secondary"
            :color="$config.colors.on.secondary"
            @click="$router.push('/cursos')"
            v-html="$config.strings['home-catalog-btn']"
            :size='"lg"'
          />
        </div>

      </div>

      <t-detail
        ref="detail"
        :loading="loading"
        :detail="detail"
        :error="detailError"
      />
    </div>
    <a v-if="$config.featureFlags['EXIBIR_BANNER_LINK']" class="banner-link" :href="$config.urls.banner_link" :style="{ '--banner-aspect-ratio': $forSize['phone-only'] ? 0.48 : 0.1728 }">
      <img class="banner-link-img" :src="$forSize['phone-only'] ? $config.images.bannerLinkMobile : $config.images.bannerLink"/>
    </a>
    <t-footer v-if="$forSize['desktop-up']" />
  </div>
</template>

<script>
import {
  TFooter,
  THSList,
  TButton,
  TParallaxBar,
  TDetail
} from '@/components/base'
import BtnMenu from '@/components/common/MenuButton'
import Routes from '@/components/common/Routes'
import BarraAssinatura from '@/components/Home/BarraAssinatura'
import LoginMenu from '@/components/common/LoginMenu'
import LoginCard from '@/components/Home/LoginCard'
import { mapActions, mapState } from 'vuex'
import { sampleSize } from 'lodash'
import { ID_SISTEMA_RAIZ, ID_SISTEMA_WOLIFLIX } from '@/constants'

export default {
  name: 'PageHome',
  components: {
    LoginCard,
    BarraAssinatura,
    Routes,
    TFooter,
    [THSList.name]: THSList,
    TButton,
    TParallaxBar,
    TDetail,
    BtnMenu,
    LoginMenu
  },
  data () {
    return {
      loading: false,
      detailError: ''
    }
  },
  computed: {
    ...mapState({
      sample: (state) =>
        sampleSize(
          [
            ...(state.cursos[ID_SISTEMA_RAIZ] || []).map(
              (categoria) => categoria.cursos
            )
          ].flat(),
          25
        ),
      sample2: (state) =>
        sampleSize(
          [
            ...(state.cursos[ID_SISTEMA_WOLIFLIX] || []).map(
              (categoria) => categoria.cursos
            )
          ].flat(),
          25
        ),
      detail: (state) => state.detail
    }),
    sysVersion () { return `Versão: ${VERSION}` }
  },
  mounted () {
    this.getCursos(ID_SISTEMA_RAIZ)
    this.getCursos(ID_SISTEMA_WOLIFLIX)
  },
  methods: {
    ...mapActions(['getCursos', 'getDetail']),
    resetarErro (key) {
      this.$set(this.errors, key, '')
    },
    showDetail (activeCard, curso) {
      this.detailError = ''
      const t = setTimeout(() => {
        this.loading = true
      }, 250)
      this.$refs.detail.show(activeCard)
      this.getDetail(curso.id)
        .catch((error) => {
          if (error.response.status === 404) {
            this.detailError = this.$config.strings['s048']
          }
        })
        .finally(() => {
          clearTimeout(t)
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
$footer-height: 92px;

.img-page-title {
  background-repeat: no-repeat;
  height: 55px;
  background-size: contain;
  background-position: center;
  margin-bottom: 35px;
  margin-top: 35px;
}

.page-home {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: inherit;
    background-color: var(--primary);

  .logo {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    max-width: 150px;
    padding: 13px;
  }

  .mobile-logo {
    max-width: 100px;
  }

  .ebook-premiado-img {
    > img {
      min-width: 175px;
      max-width: 100%;
    }
  }

  .header-content-description {
    > * {
      display: block;
      padding-bottom: 24px;
      padding-right: 13px;
      padding-left: 13px;
      font-size: 16px;

      &:first-child {
        font-size: 20px;
        font-weight: bolder;
        padding-top: 16px;

        @include for-size(desktop-up) {
          padding-top: initial;
        }
      }
    }
  }

  .router-items {
    height: 100px;
    display: flex;
    justify-content: end;
  }

  .content {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    background-color: var(--primary);
    color: var(--on-primary);
    padding: 16px 0;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 3% 0%;

    @include for-size(phone-only) {
      background-position: 8% 0%;
    }

    @include for-size(desktop-up) {
      background-position: 8% 0%;
    }

    .page-title {
      @include container-element;
      padding-top: initial;
      padding-bottom: initial;
      font-weight: bolder;
      text-align: left;
      line-height: 1.37;
      text-transform: initial;
    }

    .page-description {
      @include container-element;
      text-align: left;
      line-height: 1.67;
    }
  }

  .btn-ver-todos-os-cursos {
    padding-top: 25px;
    padding-bottom: 50px;
    text-align: center;
    width: 100%;

    > button {
      padding: 12.5px 25px;
    }
  }

  .banner-link {
    height: calc(100vw * var(--banner-aspect-ratio));
    width: 100%;
  }
  .banner-link-img {
    height: 100%;
    width: 100%;
    cursor: pointer;
    transition: filter 150ms ease-in-out;
  }

  .banner-link-img:hover {
    filter: brightness(1.05) saturate(1.05) contrast(1.05);
  }
}
</style>
